import React from "react";
import './keyDates.css';

function KeyDates() {

    return (
        <div className="keydates">
            <h2 className="compTitle">Key Dates</h2>
            <table style={{marginLeft: 'auto', marginRight: 'auto', textAlign: 'left'}}>
                <tr>
                    <td style={{width: 'max-content'}}>July 15, 2023</td>
                    <td style={{paddingLeft: '2vmax'}}>Last date for receipt of abstracts</td>
                </tr>
                <tr>
                    <td>Jul 01, 2023</td>
                    <td style={{paddingLeft: '2vmax'}}>Intimation of acceptance of abstracts</td>
                </tr>
                <tr>
                    <td>Oct 08, 2023</td>
                    <td style={{paddingLeft: '2vmax'}}>Last date of receipt of full length paper</td>
                </tr>
                <tr>
                    <td>Oct 15, 2023</td>
                    <td style={{paddingLeft: '2vmax'}}>Intimation of acceptance of full paper</td>
                </tr>
                <tr>
                    <td>Oct 30, 2023</td>
                    <td style={{paddingLeft: '2vmax'}}>Last date of receipt of camera ready paper</td>
                </tr>
            </table>
            {/* <div style={{paddingBottom: '3vmax'}}></div>
            <h2 className="compTitle">Full Paper Submission Template</h2>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3vmax'}}>
                <a onClick={downloadTemplate} style={{width: 'fit-content', padding: '0.5vmax 3vmax'}} className="download">Download Word Template</a>
            </div> */}
        </div>
    )
}

export default KeyDates;